import React from 'react';
import { Switch } from "@m/alchemy-ui/Switch";
import StyledVersionToggle from "./StyledVersionToggle";
import EyeSVG from '../../assets/eye.svg';
import { connect } from "react-redux";
import { reloadPage } from "../../services/urlGeneratorService";

class VersionToggle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowV2Survey: this.props.versionToPresent === 'V2'
    }
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    this.setState({
      isShowV2Survey: !this.state.isShowV2Survey
    }, () => {
      const { provisions, ...rest } = this.props.app;
      const versionToPresent = this.state.isShowV2Survey ? 'V2' : 'V1';
      setTimeout(reloadPage, 500, {
        ...rest,
        customParams: this.props.customParams,
        hostingElement: this.props.hostingElement,
        versionToPresent
      })
    });
  }

  render() {
    return (
      <StyledVersionToggle>
        <img src={EyeSVG} alt='' />
        <p>New survey form</p>
        <Switch checked={this.state.isShowV2Survey} onChange={this.handleToggle}/>
      </StyledVersionToggle>
    )
  }
}

function mapStateToProps({ app, customParams, hostingElement}) {
  return {
    app,
    customParams,
    hostingElement
  }
}

export default connect(mapStateToProps, {})(VersionToggle);